interface CaseHeaderProps {
  caseName: string;
  clientName: string | null;
}

export default function CaseHeader({ caseName, clientName }: CaseHeaderProps) {
  const title = clientName || caseName;
  const subtitle = caseName !== title ? caseName : null;

  return (
    <div
      data-surface="chrome"
      className="bg-chrome-bg text-chrome-text h-16 flex-shrink-0 px-6 flex items-center justify-between border-b border-chrome-sep transition-colors"
    >
      <div className="min-w-0 flex-1">
        <h1 className="t-section truncate text-chrome-text-strong">{title}</h1>
        {subtitle && (
          <p className="text-chrome-muted text-sm truncate">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
